import AbstractBandsCalculator from "./abstract-bands-calculator";

export default class UmbrellaEmployerNationalInsuranceCalculator extends AbstractBandsCalculator {
    constructor(employee, salary, bands) {
        super(salary, bands);
        this.employee = employee;
    }

    calculate() {
        return this.calculateBand('st');
    }

    getDeductableIncome() {
        return this.salary.getGross('year');
    }

    calculateBand(band) {
        let deductable = 0;
        const income = this.getDeductableIncome();

        const bandRate = this.bands.getRate(band);
        const bandMin = this.bands.getMin(band);
        const bandMax = this.bands.getMax(band);

        if (!bandRate) {
            return deductable;
        }

        if (income > bandMin) {
            let incomeWithinBand;
            if (bandMax && income > bandMax) {
                incomeWithinBand = bandMax - bandMin;
            } else {
                incomeWithinBand = income - bandMin;
            }

            deductable = ((incomeWithinBand * 100) / (100 + (bandRate * 100))) * bandRate;
        }

        return deductable;
    }
}